import { Outlet } from "react-router-dom";
import DeclarationBanner from "./components/DeclarationBanner";
import "./styles.css";

export default function Layout() {

  return (
    <>
      <DeclarationBanner />
      <Outlet />
    </>
  );
}
